export default __webpack_public_path__ + "static/media/Hallticket6.ba08a911.jpg";